"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// DON"T REMOVE - USED Server Side - Exported in 'lib/helpers'
const capitalizeString = (str) => {
    return Boolean(str)
        ? `${str}`.replace(/[\wÀ-ÿ]+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        : '';
};
// slugify('This WorKing') => 'this-working'
const slugify = (str) => String(str || '')
    .replace(/[^a-z0-9]/gi, '-')
    .toLowerCase()
    .replace(/-{2,}/g, '-') // Remove Multiple '-': 'this-is---a-link' => 'this-is-a-link'
    .replace(/^-/, '') // Remove Starting `-`
    .replace(/-$/, '');
// Remove Trailing '-'
const slugifyTitle = (str) => slugify(str)
    .split('-')
    .filter(Boolean)
    .map(capitalizeString)
    .join('-');
// Expects a object => { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... }
// Will return a new Object => { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... }
const buildSlugifyObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [slugify(key)]: key })), {});
const buildObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [key]: key })), {});
// Special mapping for installation_type facet values
const buildInstallationTypeObject = (obj) => {
    const installationTypeMapping = {
        'wall_mounted': 'wall-mounted',
        'free_standing': 'free-standing'
    };
    return Object.keys(obj).reduce((results, key) => {
        const mappedKey = installationTypeMapping[key] || key;
        return Object.assign(Object.assign({}, results), { [mappedKey]: key });
    }, {});
};
// Expects a object => { facets: { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... } }
// Will return a new Object => { facets: { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... } }
const buildSlugifyDictionary = (obj) => Object.entries(obj).reduce((results, [key, value]) => {
    if (key.search(/curated_status/) > -1) {
        // Skip these values - do NOT slugify
        return Object.assign(Object.assign({}, results), { [key]: buildObject(value) });
    }
    else if (key === 'installation_type') {
        // Use custom mapping for installation_type
        return Object.assign(Object.assign({}, results), { [key]: buildInstallationTypeObject(value) });
    }
    else {
        return Object.assign(Object.assign({}, results), { [key]: buildSlugifyObject(value) });
    }
}, {});
module.exports = {
    buildSlugifyDictionary,
    buildSlugifyObject,
    capitalizeString,
    slugify,
    slugifyTitle,
};
